<template>
  <a-select
    showSearch
    :placeholder="placeholder"
    optionFilterProp="children"
    :filterOption="filterOption"
    v-on="$allListeners"
    v-bind="$attrs"
    v-model="selectValue"
    labelInValue
    :getPopupContainer=" triggerNode => triggerNode.parentNode || document.body"
  >
    <a-select-option
      v-for="item in options"
      :value="item[valuePath]"
      :key="item[computedKyePath]"
    >{{item[labelPath]}}</a-select-option>
  </a-select>
</template>
<script>
export default {
  name: "aiSelect",
  inheritAttrs: false,
  model: {
    prop: "initValue",
    event: "input"
  },
  props: {
    placeholder: {
      type: String,
      default: "Select language"
    },
    options: {
      type: Array,
      default: () => []
    },
    valuePath: {
      type: String,
      default: "value"
    },
    labelPath: {
      type: String,
      default: "label"
    },
    keyPath: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: "150px"
    },
    initValue: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      selectValue: ""
    };
  },
  watch: {
    initValue: {
      handler(val) {
        this.selectValue = { key: val };
      },
      immediate: true
    }
  },
  computed: {
    computedKyePath() {
      let path = this.keyPath || this.valuePath;
      return path;
    },
    $allListeners() {
      return Object.assign({}, this.$listeners, {
        input: this.onInput
      });
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onInput(val) {
      this.$emit("input", val.key);
    }
  }
};
</script>
